// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"251":"838a813b","698":"96d45004","707":"619146ff","779":"66bb2abc"}[chunkId] + ".chunk.css";
};